// Test with https://caiorss.github.io/bookmarklet-maker/?title=testing
// Replicate that functionality on server side

export const version = "1.1.0";

function bookmarkletFunction() {
  const bookmarkletVersion = "1.1.0";

  function getShareSVG() {
    return `
    <svg
    class="vrshare-modal-link-go"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    width="100.94717mm"
    height="98.461067mm"
    viewBox="0 0 100.94717 98.461067"
    version="1.1"
    id="svg8"
    sodipodi:docname="share-white.svg"
    inkscape:version="1.0.2-2 (e86c870879, 2021-01-15)">
    <defs
      id="defs2">
      <clipPath
        clipPathUnits="userSpaceOnUse"
        id="clipPath849">
        <path
          d="M 0,947.691 H 682.805 V 0 H 0 Z"
          id="path847" />
      </clipPath>
    </defs>
    <sodipodi:namedview
      id="base"
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1.0"
      inkscape:pageopacity="0.0"
      inkscape:pageshadow="2"
      inkscape:zoom="0.35"
      inkscape:cx="197.14504"
      inkscape:cy="168.61518"
      inkscape:document-units="mm"
      inkscape:current-layer="layer1"
      inkscape:document-rotation="0"
      showgrid="false"
      inkscape:window-width="1280"
      inkscape:window-height="1001"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      fit-margin-top="0"
      fit-margin-left="0"
      fit-margin-right="0"
      fit-margin-bottom="0" />
    <metadata
      id="metadata5">
      <rdf:RDF>
        <cc:Work
          rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title></dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      transform="translate(-53.672042,-103.5539)">
      <g
        id="g859"
        transform="matrix(0.35277777,0,0,-0.35277777,105.92617,169.36583)"
        style="fill:#000000;fill-opacity:1;stroke:#ffffff;stroke-width:14.1732;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1">
        <path
          d="m 0,0 v -3.318 c 0,-15.513 0,-31.027 0.001,-46.539 0,-2.719 -0.008,-5.438 0.016,-8.156 0.024,-2.659 1.29,-4.583 3.646,-5.737 2.419,-1.185 4.807,-1.065 7.024,0.534 0.708,0.512 1.338,1.139 1.964,1.753 36.803,36.143 73.602,72.288 110.397,108.439 0.568,0.558 1.143,1.129 1.606,1.773 1.786,2.478 1.747,5.357 -0.088,7.791 -0.43,0.571 -0.946,1.082 -1.448,1.596 -36.876,37.761 -73.755,75.521 -110.639,113.277 -0.556,0.57 -1.129,1.139 -1.766,1.614 -2.211,1.654 -4.619,1.697 -7.025,0.564 -2.376,-1.117 -3.595,-3.085 -3.669,-5.726 -0.025,-0.879 -0.018,-1.759 -0.018,-2.638 C 0,147.075 0,128.924 0,110.772 v -2.857 c -0.735,-0.122 -1.195,-0.217 -1.66,-0.271 -5.238,-0.61 -10.519,-0.974 -15.71,-1.861 -21.644,-3.701 -41.021,-12.525 -58.153,-26.249 -17.32,-13.875 -30.007,-31.328 -39.356,-51.307 -9.954,-21.276 -15.454,-43.805 -18.385,-66.999 -1.061,-8.399 -1.628,-16.862 -2.313,-25.305 -0.272,-3.343 -0.319,-6.709 -0.35,-10.067 -0.026,-2.961 1.622,-5.13 4.299,-5.946 2.547,-0.777 4.969,0.139 6.641,2.563 0.633,0.92 1.186,1.897 1.764,2.855 6.922,11.447 14.546,22.393 23.329,32.502 8.541,9.83 18.062,18.552 29.056,25.608 15.238,9.779 32.061,14.578 49.986,15.803 6.061,0.414 12.142,0.518 18.214,0.754 C -1.865,0.025 -1.09,0 0,0 m -5.138,-5.422 c -2.773,0 -5.083,0.043 -7.39,-0.007 -11.08,-0.239 -21.999,-1.582 -32.63,-4.851 -12.873,-3.96 -24.308,-10.504 -34.593,-19.149 -9.73,-8.177 -18.088,-17.609 -25.646,-27.787 -5.25,-7.067 -10.104,-14.396 -14.534,-22.003 -1.773,-3.044 -4.17,-5.21 -7.698,-5.99 -6.568,-1.451 -13.006,3.249 -13.324,9.976 -0.174,3.665 -0.058,7.364 0.223,11.024 0.642,8.366 1.229,16.747 2.259,25.069 3.102,25.054 9.099,49.328 20.198,72.159 10.565,21.732 25.098,40.226 44.718,54.522 16.091,11.724 33.998,19.302 53.553,22.951 4.394,0.82 8.859,1.253 13.292,1.866 0.39,0.054 0.776,0.127 1.43,0.235 0.048,1.019 0.136,2.026 0.136,3.032 0.009,16.712 0.001,33.424 0.016,50.136 0.001,1.436 -0.038,2.903 0.228,4.301 1.558,8.209 11.748,12.175 18.476,7.211 1.023,-0.755 1.957,-1.648 2.849,-2.56 36.73,-37.567 73.457,-75.138 110.154,-112.738 1.267,-1.299 2.484,-2.769 3.282,-4.379 2.207,-4.457 1.476,-8.689 -1.583,-12.542 -0.544,-0.686 -1.198,-1.287 -1.825,-1.904 C 89.61,6.937 52.729,-29.235 15.962,-65.526 c -5.045,-4.98 -11.936,-4.939 -16.128,-1.901 -3.023,2.192 -4.827,5.091 -4.919,8.885 -0.076,3.116 -0.05,6.236 -0.051,9.354 -0.004,13.593 -0.002,27.187 -0.002,40.78 z"
          style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:#ffffff;stroke-width:14.1732;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
          id="path861" />
      </g>
    </g>
  </svg>
    `;
  }

  function getPopupText(pageUrl, embeddedMediaUrls, mediaLinkUrls, frameUrls) {
    return `
    <div class="vrshare-modal__overlay vrshare-overlay"></div>
    <div class="vrshare-modal__container">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice" class="vrshare-modal-background-svg">
        <rect width="100%" height="100%" fill="#000" />
        <g transform="translate(0 27.638)" fill="#ad0067">
          <path d="m0 875.71v8.6445h1920v-8.6445z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m-2.5e-5 754.31 2.5e-5 5.7567h1920v-5.757z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 673.4-2.5e-5 3.8216h1920v-3.8216z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 619.43v2.5586h1920v-2.5586z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 583.46v1.7031h1920v-1.7031z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 559.48v1.1406h1920v-1.1406z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 543.5v0.7539l1920 2e-4v-0.7539z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 532.84v0.50781h1920v-0.50781z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 525.73v0.33594l1920 2.9e-4v-0.33594z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 521v0.22265h1920v-0.22265z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 517.84v0.14062h1920v-0.14062z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m0 515.73v0.10157l1920-1.4e-4v-0.10157z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m-2.5e-5 513.38v0.0937h1920v-0.0937h-1920z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m-2.5e-5 512.75v0.0942l1920-5e-4v-0.0937z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m-2.5e-5 512.31v0.0937h1920v-0.0937h-1920z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
          <path d="m-2.5e-5 514.31v0.0937h1920v-0.0937h-1920z" color="#000000" opacity=".99" style="block-progression:tb;text-indent:0;text-transform:none"/>
        </g>
        <g transform="translate(0,-840)" fill="#ad0067" fill-rule="evenodd">
          <path d="m-0.020694 1920c320.01-180 640.01-360 960.02-540-311.68 180-623.36 360-935.03 540h-24.988z"/>
          <path d="m0 1752v-8.6363c320-121.12 640-242.23 960-363.35h5e-5c-320 123.99-640 247.99-960 371.98z" stroke-width="0"/>
          <path d="m0 1541c320-53.678 640-107.36 960-161.04-320 54.953-640 109.91-960 164.86" stroke-width="0"/>
          <path d="m0 1489.6v-2.5586h9.6141e-5l960-107.07h5e-5c-320 36.543-640 73.086-960 109.63z" stroke-width="0"/>
          <path d="m0 1451.1c320-23.7 640-47.401 960-71.102-320 24.268-640 48.536-960 72.805" stroke-width="0"/>
          <path d="m0 1428.3v-1.1406h9.606e-5c320-15.706 640-31.412 960-47.117h5e-5l-960 48.258z" stroke-width="0"/>
          <path d="m0 1411.9v-0.7539l960-31.137h1e-4l-960 31.891z" stroke-width="0"/>
          <path d="m0 1627.7v-5.7578h9.6348e-5l960-241.95h5e-5l-960 247.71z" stroke-width="0"/>
          <path d="m0 1401v-0.5078c320-6.8255 640-13.651 960-20.477h5e-5l-960 20.984z" stroke-width="0"/>
          <path d="m0 1393.4v0.3359c320-4.5569 640-9.1175 960-13.707h5e-5c-320 4.457-640 8.9141-960 13.371z" stroke-width="0"/>
          <path d="m0 1388.6v0.2227c320-2.9531 640-5.9063 960-8.8594h5e-5l-960 8.6367z" stroke-width="0"/>
          <path d="m0 1385.5c320-1.8268 640-3.6537 960-5.4805l-960 5.6211" stroke-width="0"/>
          <path d="m0 1383.5v-0.1016l960-3.3711h5e-5c-320 1.1576-640 2.3151-960 3.4727z" stroke-width="0"/>
          <path d="m-0.0055868 1382.1c320-0.689 640-1.3781 960-2.0671-320 0.689-640 1.3781-960 2.0671z" stroke-width="0"/>
          <path d="m378.88 1920c193.71-180 387.42-360 581.12-540-2e-5 0-4e-5 0-6e-5 1e-4 -185.38 180-370.75 360-556.13 540h-24.994z"/>
          <path d="m757.78 1920c67.406-180 134.81-360 202.22-540-1e-5 0-1e-5 0-2e-5 1e-4 -59.075 180-118.15 360-177.22 540h-24.994z"/>
          <path d="m1920 1920c-320.01-180-640.01-360-960.02-540 3e-5 0 6e-5 0 1e-4 1e-4 311.68 180 623.36 360 935.03 540h24.988z"/>
          <path d="m1541.1 1920c-193.71-180-387.42-360-581.12-540 2e-5 0 4e-5 0 6e-5 1e-4 185.38 180 370.75 360 556.13 540h24.994z"/>
          <path d="m1162.2 1920c-67.406-180-134.81-360-202.22-540 1e-5 0 1e-5 0 2e-5 1e-4 59.075 180 118.15 360 177.22 540h24.994z"/>
          <path d="m1920 1752v-8.6363h-1e-4c-320-121.12-640-242.23-960-363.35h-5e-5c320 123.99 640 247.99 960 371.98z" stroke-width="0"/>
          <path d="m1920 1541c-320-53.678-640-107.36-960-161.04 320 54.953 640 109.91 960 164.86" stroke-width="0"/>
          <path d="m1920 1489.6v-2.5586h-1e-4c-320-35.69-640-71.38-960.01-107.07h-5e-5c320 36.543 640 73.086 960.01 109.63z" stroke-width="0"/>
          <path d="m1920 1451.1c-320-23.7-640-47.401-960.01-71.102 320 24.268 640 48.536 960.01 72.805" stroke-width="0"/>
          <path d="m1920 1428.3v-1.1406c-320-15.706-640-31.412-960.01-47.117h-5e-5c320 16.086 640 32.172 960.01 48.258z" stroke-width="0"/>
          <path d="m1920 1411.9v-0.7539h-1e-4c-320-10.379-640-20.758-960.01-31.137h-5e-5c320 10.63 640 21.26 960.01 31.891z" stroke-width="0"/>
          <path d="m1920 1627.7v-5.757c-320-80.65-640-161.3-960.01-241.95h-5e-5c320 82.569 640 165.14 960.01 247.71z" stroke-width="0"/>
          <path d="m1920 1401v-0.5078c-320-6.8255-640-13.651-960.01-20.477h-1e-4c320 6.9948 640 13.99 960.01 20.984z" stroke-width="0"/>
          <path d="m1920 1393.4v0.3359c-320-4.5569-640-9.1175-960-13.707h-5e-5c320 4.457 640 8.9141 960 13.371z" stroke-width="0"/>
          <path d="m1920 1388.6v0.2227h-1e-4c-320-2.9531-640-5.9063-960.01-8.8594h-5e-5c320 2.8789 640 5.7578 960.01 8.6367z" stroke-width="0"/>
          <path d="m1920 1385.5c-320-1.8268-640-3.6537-960.01-5.4805 320 1.8737 640 3.7474 960.01 5.6211" stroke-width="0"/>
          <path d="m1920 1383.5v-0.1016h-1e-4c-320-1.1237-640-2.2474-960.01-3.3711h-5e-5c320 1.1576 640 2.3151 960.01 3.4727z" stroke-width="0"/>
          <path d="m1920 1382.1c-320-0.689-640-1.3781-960-2.0671 320 0.689 640 1.3781 960 2.0671z" stroke-width="0"/>
          <path d="m0 1382v-0.092l960-1.95h5e-5c-320 0.6807-640 1.3613-960 2.042z" stroke-width="0"/>
          <path d="m1920 1382v-0.092l-960-1.95h-5e-5c320 0.6807 640 1.3613 960 2.042z" stroke-width="0"/>
          <path d="m0 1381.1l960-1.107-960 1.107z" stroke-width="0"/>
          <path d="m960 1381.1l-960-1.107 960 1.107z" stroke-width="0"/>
          <path d="m0 1381.1c320-0.3677 640-0.7353 960-1.103-320 0.3677-640 0.7353-960 1.103z" stroke-width="0"/>
          <path d="m1920 1381.1c-320-0.3677-640-0.7353-960-1.103 320 0.3677 640 0.7353 960 1.103z" stroke-width="0"/>
          <path d="m0 1380.5v-0.094c320-0.1293 640-0.2587 960-0.388h5e-5c-320 0.1607-640 0.3213-960 0.482z" stroke-width="0"/>
          <path d="m1920 1380.5v-0.094c-320-0.1293-640-0.2587-960-0.388h-5e-5c320 0.1607 640 0.3213 960 0.482z" stroke-width="0"/>
          <path d="m0 1381.1v-0.094h9.6005e-5c320-0.3377 640-0.6753 960-1.013h5e-5l-960 1.107z" stroke-width="0"/>
          <path d="m1920 1381.1v-0.094h-1e-4c-320-0.3377-640-0.6753-960-1.013h-5e-5l960 1.107z" stroke-width="0"/>
        </g>
      </svg>
      <div class="vrshare-modal__contents">
        <h2 class="vrshare-modal-title">Send to VRShare.app</h2>
        ${pageUrl
          ? `<p class="vrshare-modal-text vrshare-modal-keep-with-next"><b>Use page URL:</b></p><p class="vrshare-modal-text"><a class="vrshare-modal-link" href="https://vrshare.app/?url=${encodeURIComponent(pageUrl)}&bookmarklet=${bookmarkletVersion}" target="_blank" rel="noopener noreferrer">${pageUrl}${getShareSVG()}</a></p>`
          : `<p class="vrshare-modal-text">Use page URL:</p><p class="vrshare-modal-text">This page cannot be shared via VRShare - it is either not served over https or http, or it is a VRShare.app page</p>`
        }
        ${Array.isArray(embeddedMediaUrls) && embeddedMediaUrls.length > 0
          ? `<p class="vrshare-modal-text vrshare-modal-keep-with-next"><b>Use an embedded media URL:</b></p><ul>${embeddedMediaUrls.map((url) => `<li><a class="vrshare-modal-link" href="https://vrshare.app/?url=${encodeURIComponent(url)}&bookmarklet=${bookmarkletVersion}" target="_blank" rel="noopener noreferrer">${url}${getShareSVG()}</a></li>`).join('\n')}</ul>`
          : ''
        }
        ${Array.isArray(mediaLinkUrls) && mediaLinkUrls.length > 0
          ? `<p class="vrshare-modal-text vrshare-modal-keep-with-next"><b>Use media link URL:</b></p><ul>${mediaLinkUrls.map((url) => `<li><a class="vrshare-modal-link" href="https://vrshare.app/?url=${encodeURIComponent(url)}&bookmarklet=${bookmarkletVersion}" target="_blank" rel="noopener noreferrer">${url}${getShareSVG()}</a></li>`).join('\n')}</ul>`
          : ''
        }
        ${Array.isArray(frameUrls) && frameUrls.length > 0
          ? `<p class="vrshare-modal-text vrshare-modal-keep-with-next"><b>Use a frame URL:</b></p><ul>${frameUrls.map((url) => `<li><a class="vrshare-modal-link" href="https://vrshare.app/?url=${encodeURIComponent(url)}&bookmarklet=${bookmarkletVersion}" target="_blank" rel="noopener noreferrer">${url}${getShareSVG()}</a></li>`).join('\n')}</ul>`
          : ''
        }
        <a class="vrshare-modal__close vrshare-modal-link" href="${window.location.href}" target="_self" onclick="document.getElementById('vrshare-bookmarklet-content').classList.remove('open'); return false;">&#10005;</a>
      </div>
    </div>`;
  }

  function getStyles() {
    return `
    .vrshare-modal {
      --themeMainColorDecRGB: 173, 0, 103;
      --themeAccentColorDecRGB: 255, 255, 255;
      --themeMainColor: rgb(var(--themeMainColorDecRGB));
      --themeAccentColor: rgb(var(--themeAccentColorDecRGB));
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 20;
      padding: 30px;
      width:  100%;
      height: 100%;
      margin: 0;
      padding: 0;
      opacity: 0;
      visibility: hidden;
      transition:visibility 0s linear 0.1s,opacity 0.3s ease;
    }
    .vrshare-modal.open {
      visibility:visible;
      opacity: 1;
      transition-delay:0s;
    }
    .vrshare-modal__overlay {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 21;
      background-color: rgba(0,0,0,0.7);
    }
    .vrshare-modal__close {
      position: absolute;
      top: 10px;
      right: 10px;
      border: 0.1em hidden;
      box-sizing: border-box;
      box-shadow: none;
      outline: none;
      background: none;
      font-size: 24px;
      color: var(--themeAccentColor);
      font-weight: bold;
      padding: 0 1vmin;
    }
    .vrshare-modal__container {
      position: relative;
      z-index: 22;
      width: 60vw;
      height: 40vh;
      top: 50%;
      transform: translateY(-50%);
      box-shadow: 0 0 10px var(--themeAccentColor);
      margin: 0 auto;
      padding: 6vmin;
      background-size: cover;
      display: flex;
      align-items: center;
      flex-direction: column;
      align-content: center;
      justify-content: center;
    }
    .vrshare-modal-background-svg {
      position: fixed;
      width: 100%;
      height: 100%;
      z-index: 23;
    }
    .vrshare-modal__contents {
      z-index: 24;
      display: flex;
      align-items: center;
      flex-direction: column;
      align-content: center;
      justify-content: flex-start;
      overflow-y: auto;
    }
    .vrshare-modal__contents::-webkit-scrollbar {
      width: 10px;
    }
    
    .vrshare-modal__contents::-webkit-scrollbar-track {
      background: rgba(var(--themeAccentColorDecRGB), 0.1);
    }
    
    .vrshare-modal__contents::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: var(--themeMainColor);
      border: 0px solid var(--themeAccentColor);
    }
    .vrshare-modal-text {
      color: var(--themeAccentColor);
      font-family:'Roboto',Arial,sans-serif;
      font-weight:300;
      font-size: 2vmin;
      text-align:left;
      margin-bottom: 4vmin;
    }
    .vrshare-modal-keep-with-next {
      margin-bottom: 0;
    }
    .vrshare-modal-title {
      color: var(--themeAccentColor);
      font-family:'Orbitron','Roboto',Arial,sans-serif;
      font-weight:700;
      font-size: 3vmin;
      text-align:left;
      margin-bottom: 4vmin;
      margin-top: 1vmin;
    }
    .vrshare-modal-link {
      display:inline-block;
      padding:0.35em 1.2em;
      border:0.1em solid rbga(0,0,0,0);
      box-shadow: none;
      border-radius:0.12em;
      box-sizing: border-box;
      margin: 0 0.3em 0.3em 0;
      text-decoration:none !important;
      font-family:'Roboto',Arial,sans-serif;
      font-weight:300;
      font-size: 2vmin;
      text-align:left;
      transition: all 0.2s;
      background-position: center;
      transition: background 0.8s;
      color: var(--themeAccentColor) !important;
      background: rgba(var(--themeAccentColorDecRGB), 0);
      word-wrap: break-word;
      max-width: 50vw;
    }  
    .vrshare-modal-link:hover,
    .vrshare-modal__close:hover {
      border:0.1em solid var(--themeAccentColor);
      text-decoration: none !important;
      cursor: pointer;
    }
    .vrshare-modal-link:hover:active,
    .vrshare-modal__close:active {
      transition: border 0.3s;
      text-decoration: none !important;
    }
    .vrshare-modal-link-go {
      margin-left: 2vmin;
      height: 2vmin !important;
      width: 2vmin !important;
    }
    `;
  }

  function isAcceptableUrl(url) {
    if (!url) return false;
    try {
      const parsedUrl = new URL(url);

      const acceptableProtocol = parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
      if (!acceptableProtocol) {
        console.warn(`Link excluded - not a http or https link:\n${parsedUrl.toString()}`);
        return false;
      }

      const acceptableDomain = !parsedUrl.hostname.endsWith("vrshare.app");
      if (!acceptableDomain) {
        console.warn(`Link excluded- circular redirects are not supported, so we cannot share this URL via VRShare:\n${parsedUrl.toString()}`);
        return false;
      }
    } catch (error) {
      console.error(`Could not parse URL ${url}`);
      console.error(error);
      return false;
    }
    return true;
  }

  const pageUrl = isAcceptableUrl(window.location.href) ? window.location.href : '';
  
  const embeddedMediaUrls = Array.from(document.querySelectorAll("video"))
    .map((video) => video?.currentSrc || video?.src)
    .filter((url) => isAcceptableUrl(url));
  
  // See https://www.renderheads.com/content/docs/AVProVideo/articles/supportedmedia.html for acceptable file formats
  // Have to test if it /contains/ the file extension, as URL strings may have query parameters
  const mediaLinkUrls = Array.from(document.querySelectorAll("a[href*='.mp4'],a[href*='.webm'],a[href*='.m3u8']"))
    .map((link) => link?.href)
    .filter((url) => {
      // Now test for the extension occurring at the end of a pathname
      // else we get false positives like https://www.webmfiles.org/demo-files/ getting all links due to the leading .webm in the domain
      try {
        const parsedUrl = new URL(url);
        // See https://www.renderheads.com/content/docs/AVProVideo/articles/supportedmedia.html for acceptable file formats
        if (parsedUrl.pathname.endsWith(".mp4")
          || parsedUrl.pathname.endsWith(".webm")
          || parsedUrl.pathname.endsWith(".m3u8")) {
          return true;
        }
        return false;
      } catch (error) {
        return false;
      }
    })
    .filter((url) => isAcceptableUrl(url));
  
  const frameUrls = Array.from(document.querySelectorAll("iframe"))
    .map((iframe) => iframe?.src)
    .filter((url) => isAcceptableUrl(url));
  

  const fontId = "vrshare-bookmarklet-font";
  const fontInDocument = document.getElementById(fontId);
  if (!fontInDocument) {
    const font = document.createElement('link');
    font.id = fontId;
    font.rel = "stylesheet";
    font.href = "https://fonts.googleapis.com/css?family=Orbitron"
    document.body.appendChild(font);
  }

  const stylesId = "vrshare-bookmarklet-styles";
  const stylesInDocument = document.getElementById(stylesId);
  if (!stylesInDocument) {
    const styles = document.createElement('style');
    styles.id = stylesId;
    styles.innerHTML = getStyles();
    document.body.appendChild(styles);
  } else {
    stylesInDocument.innerHTML = getStyles();
  }

  const contentId = "vrshare-bookmarklet-content";
  const contentInDocument = document.getElementById(contentId);
  if (!contentInDocument) {
    const content = document.createElement('div');
    content.id = contentId;
    content.classList.add("vrshare-modal");
    content.classList.add("open");
    content.innerHTML = getPopupText(pageUrl, embeddedMediaUrls, mediaLinkUrls, frameUrls);
    document.body.appendChild(content);
  } else {
    contentInDocument.innerHTML = getPopupText(pageUrl, embeddedMediaUrls, mediaLinkUrls, frameUrls);
    contentInDocument.classList.add("open");
  }
}

export default bookmarkletFunction;